export class CsrfTokenManager {
    private static instance: CsrfTokenManager;
    private currentToken: string | null = null;
    private readonly storageKey = 'csrfToken';
  
    private constructor() {
        this.initializeToken();
    }
  
    public static getInstance(): CsrfTokenManager {
        if (!CsrfTokenManager.instance) {
            CsrfTokenManager.instance = new CsrfTokenManager();
        }
        return CsrfTokenManager.instance;
    }
  
    private initializeToken(): void {
        const storedToken = this.getStoredToken();
        if (storedToken) {
            this.currentToken = storedToken;
        } else {
            this.generateNewToken();
        }
    }
  
    public getToken(): string {
        if (!this.currentToken) {
            return this.generateNewToken();
        }
        return this.currentToken;
    }
  
    public generateNewToken(): string {
        let token: string;
        
        if (typeof window !== 'undefined' && window.crypto && (window.crypto as any).randomUUID) {
            token = (window.crypto as any).randomUUID();
        } else {
            token = this.generateFallbackToken();
        }
    
        this.currentToken = token;
        this.storeToken(token);
        return token;
    }
    
  
    private generateFallbackToken(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
  
    private getStoredToken(): string | null {
        try {
            return localStorage.getItem(this.storageKey);
        } catch (error) {
            console.error('Error reading from localStorage:', error);
            return null;
        }
    }
  
    private storeToken(token: string): void {
        try {
            localStorage.setItem(this.storageKey, token);
        } catch (error) {
            console.error('Error writing to localStorage:', error);
        }
    }
  }